import * as Yup from 'yup';
import * as moment from 'moment';
import { stateConvert, abbreviationToState } from 'web/components/utils/stateAbbreviation';

export function setInitialValues(draftData) {
  let rateFromDate = moment().format('MM/DD/YYYY');
  let rateToDate = new Date();
  let oneMonth = rateToDate.setMonth(rateToDate.getMonth() + 12)
  rateToDate = moment(oneMonth).format('MM/DD/YYYY')

  return {
    //basic info
    userName: draftData?.customerName ? draftData?.customerName : '',
    phoneNumber: draftData?.contactNumber ? draftData?.contactNumber : '',
    businessName: draftData?.locationName ? draftData?.locationName : '',
    email: draftData?.emailAddress ? draftData?.emailAddress : '',
    address: draftData?.locationAddress?.street ? draftData?.locationAddress?.street : '',
    city: draftData?.locationAddress?.city ? draftData?.locationAddress?.city : '',
    state: draftData?.locationAddress?.state ? (stateConvert(draftData?.locationAddress?.state) || draftData?.locationAddress?.state) : '',
    // state: draftData?.locationAddress?.state ? draftData?.locationAddress?.state : '',
    zip: draftData?.locationAddress?.zipCode ? draftData?.locationAddress?.zipCode : '',
    notes: draftData?.notes ? draftData?.notes : '',

    //bill To
    billToCheckBox: false,
    billToUserName: draftData?.billingAddress?.name ? draftData?.billingAddress?.name : '',
    billToEmail: draftData?.billToEmailAddress ? draftData?.billToEmailAddress : '',
    billToPhoneNumber: draftData?.billingAddress?.contactNumber ? draftData?.billingAddress?.contactNumber : '',
    billToBusinessName: draftData?.billingAddress?.locationName ? draftData?.billingAddress?.locationName : '',
    billToAddress: draftData?.billingAddress?.street ? draftData?.billingAddress?.street : '',
    billToCity: draftData?.billingAddress?.city ? draftData?.billingAddress?.city : '',
    billToState: draftData?.billingAddress?.state ? (stateConvert(draftData?.billingAddress?.state) || draftData?.billingAddress?.state) : '',
    billToZip: draftData?.billingAddress?.zipCode ? draftData?.billingAddress?.zipCode : '',
    taxId: draftData?.businessInfo?.taxId ? draftData?.businessInfo?.taxId : '',
    businessURL: draftData?.businessInfo?.businessUrl ? draftData?.businessInfo?.businessUrl : '',
    businessDescription: draftData?.businessInfo?.businessDescription ? draftData?.businessInfo?.businessDescription : '',
    otherToEmail: draftData?.otherContactEmail ? draftData?.otherContactEmail : '',
    //fee structure
    feeTypeRadio: draftData?.feeStructure?.feeType ? draftData?.feeStructure?.feeType : 'PERCENTAGE',
    percentageValue: draftData?.feeStructure?.feeTypePercentage?.fee ? draftData?.feeStructure?.feeTypePercentage?.fee : '',
    //percentageValue:  '',
    costPerPalletValue: draftData?.feeStructure?.feeTypeCostPallet?.fee ? draftData?.feeStructure?.feeTypeCostPallet?.fee : '',
    percentageCurrencyLists: draftData?.feeStructure?.feeTypePercentage?.currency ? draftData?.feeStructure?.feeTypePercentage?.currency : 'USD',
    costPerPalletCurrencyLists: draftData?.feeStructure?.feeTypeCostPallet?.currency ? draftData?.feeStructure?.feeTypeCostPallet?.currency : 'USD',
    selectLocation: draftData?.locationName ? draftData?.locationName : '', // as of now location name in basic info is set here as well
    selectPalletType: draftData?.feeStructure?.flatFee?.selectedPaalletType ? draftData?.feeStructure?.flatFee?.selectedPaalletType : 'gradeA',
    comment: draftData?.comment || '',

    //flat fee
    addLocationInput: '',
    flatFeeValue: '',
    flatFeeCurrencyLists: 'USD',
    rateStartDate: rateFromDate,
    rateExpDate: rateToDate,

    material: "WOOD",
    condition0: "",
    condition1: "",
    condition2: "",
    condition3: "",
    palletType: "",
    hardOrSoftWood: '',
    moisture: "",
    size: "",
    grade: "",
    isHeatTreared: false,
    isLtl: false,
    //payment method
    paymentModeRadio: draftData?.paymentInfo?.paymentMode ? draftData?.paymentInfo?.paymentMode : 'PT',
    paymentTerm: draftData?.paymentInfo?.paymentTerm ? draftData?.paymentInfo?.paymentTerm : '',
    invoicePaymentModeRadio: 'ach',
    invoiceSchedulePeriod: draftData?.paymentInfo?.invoiceScheduled ? draftData?.paymentInfo?.invoiceScheduled : 'WEEKLY',

    // stateTaxExemption: abbreviationToState(draftData?.locationAddress?.state) ? abbreviationToState(draftData?.locationAddress?.state) :
    //     stateConvert(draftData?.locationAddress?.state) ? stateConvert(draftData?.locationAddress?.state) : '',
    stateTaxExemption: 'New York',
    
    //location setup
    addLocationName: '',
    addLocationAddress: '',
    addLocationCity: '',
    addLocationState: '',
    addLocationZip: '',
    addLocationContactNumber: '',
    addUserName: '',
    addUserEmail: '',
    addUserPhoneNumber: '',

  };
}

const VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
    //basic info
    userName: Yup.string().trim().required('Name is required.'),
    phoneNumber: Yup.string().required('Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
    businessName: Yup.string().required('Business Name is required.'),
    email: Yup.string().email('Please enter a valid email.').required('Email is required.'),
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,"Please enter a valid email."),
    address: Yup.string().required('Address is required.'),
    city: Yup.string().required('City is required.'),
    state: Yup.string().required('State is required.'),
    zip: Yup.string().required('Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
    notes: Yup.string().max(500, "Only 500 characters allowed."),

    //bill to
    billToUserName: Yup.string().trim().required('Bill To Name is required.'),
    billToEmail: Yup.string().email('Please enter a valid email.').required('Email is required.'),
    billToPhoneNumber: Yup.string().required('Bill To Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
    billToBusinessName: Yup.string().required('Bill To Business Name is required.'),
    billToAddress: Yup.string().required('Bill To Address is required.'),
    billToCity: Yup.string().required('Bill To City is required.'),
    billToState: Yup.string().required('Bill To State is required.'),
    billToZip: Yup.string().required('Bill To Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
    //business info
    taxId: Yup.string().min(9, "9 digits required.").max(9, "Tax ID should be of 9 digits only."),
    // businessURL: Yup.string().max(200, "Only 200 characters allowed."),
    // businessURL: Yup.string().max(200, "Only 200 characters allowed.").url('Invalid URL'),
    // businessURL: Yup.string().max(200, "Only 200 characters allowed.").matches(
    //     /^(https?:\/\/)?(www\.)/i,
    //     'Invalid URL'
    //   ),
    businessURL: Yup.string().max(200, "Only 200 characters allowed.").matches(
      /^(https?:\/\/(www\.)?)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?].*)?$/,
      'Invalid URL'
    ),
    businessDescription: Yup.string().max(200, "Only 200 characters allowed."),

    rateStartDate: Yup.date()
      .typeError('Start Date must be a valid date')
      .nullable()
      .required('Start Date is required')
      .test('start-date-before-end', 'Start Date must be before End Date', function (value) {
        const { rateExpDate } = this.parent;
        if (!rateExpDate || !value) return true; // No expiration date provided, so validation passes
        return moment(value, 'YYYY-MM-DD').isSameOrBefore(rateExpDate, 'day');
      }),
      rateExpDate: Yup.date()
      .typeError('End Date must be a valid date')
      .nullable()
      .required('End Date is required')
      .test('end-date-after-start', 'End Date must be after Start Date', function (value) {
        const { rateStartDate } = this.parent;
        if (!rateStartDate || !value) return true; // No start date provided, so validation passes
        return moment(value, 'YYYY-MM-DD').isSameOrAfter(rateStartDate, 'day');
      }),

    //location setup
    addLocationName: Yup.string().trim(),
    addLocationAddress: Yup.string(),
    addLocationCity: Yup.string(),
    addLocationState: Yup.string(),
    addLocationZip: Yup.string().min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
    addLocationContactNumber: Yup.string().required('Contact Number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
    addUserName: Yup.string().trim(),
    addUserPhoneNumber: Yup.string().matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
    addUserEmail: Yup.string().email('Please enter a valid email.'),
    otherToEmail: Yup.string().email('Please enter a valid email.')

  }

  return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };
